import React, { useRef } from "react";

import Fullscreen from "@mui/icons-material/Fullscreen";
import { useSynchronizedState } from "@solidwhite/multiuser";

import PlayArrowSharp from "@mui/icons-material/PlayArrowSharp";

const ModalVideoSlide = (props) => {
  const [isOpenPortal, setIsOpenPortal] = useSynchronizedState(
    `VideoPlayer`,
    false
  );

  const [videoSrc, setVideoSrc] = useSynchronizedState("VideoPlayerSrc", "");

  // const [isOpenPortal, setIsOpenPortal] = useState(false);

  const imageRef = useRef();

  const handleOpenPortal = () => {
    setVideoSrc(props.src);
    setIsOpenPortal(true);
  };

  return (
    <>
      <div
        style={{
          position: "relative",
          paddingTop: "56.25%", // Player ratio: 100 / (1280 / 720)
          cursor: "pointer",
        }}
        onClick={handleOpenPortal}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            zIndex: 1,
            userSelect: "none",
            width: "100%",
            height: "100%",
          }}
        />
        <img
          src={props.thumbnail}
          ref={imageRef}
          id={props.id}
          alt=""
          width="100%"
          height="100%"
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            objectFit: "cover",
          }}
        />
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0, 0.7)",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "9999px",
              border: `0.15vw solid #3EBA7C`,
              width: "5vw",
              height: "5vw",
            }}
          >
            <div
              style={{
                position: "absolute",
                top: 0,
                left: 0,
                boxShadow: "0px 0px 50px 5px #000 inset",
                zIndex: 1,
                userSelect: "none",
                width: "100%",
                height: "100%",
              }}
            />
            <PlayArrowSharp
              style={{
                fontSize: "4vw",
                color: "#3EBA7C",
              }}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          cursor: "pointer",
          display: "flex",
          justifyContent: "center",
          p: "0.5vw",
        }}
        onClick={handleOpenPortal}
      >
        <Fullscreen
          style={{
            color: "#fff",
            fontSize: "2vw !important",
            marginTop: "10px",
            marginRight: "10px",
          }}
        />
      </div>

      {/* <ModalWithPortal
        isOpenPortal={isOpenPortal}
        setIsOpenPortal={setIsOpenPortal}
        image={props.thumbnail}
      >
        <video src={props.src} autoPlay controls></video>

      </ModalWithPortal> */}
    </>
  );
};

export default ModalVideoSlide;
